"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RelatedTopicsSkeleton = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _Skeleton = require("@insided/shared/uikit/Skeleton");

/**
 * Placeholder while related topics credentials or Algolia results load.
 * Matches real widget layout to limit CLS and reserve vertical space.
 */
var RelatedTopicsSkeleton = function RelatedTopicsSkeleton(_ref) {
  var widgetTitle = _ref.widgetTitle,
      rowCount = _ref.rowCount;
  var safeCount = Number.isFinite(rowCount) && rowCount > 0 ? Math.min(rowCount, 10) : 3;
  var rows = Array.from({
    length: safeCount
  }, function (_, i) {
    return i;
  });
  return (0, _preact.h)("div", {
    "aria-busy": "true",
    "aria-hidden": "true",
    className: (0, _classnames.default)('box__content', 'widget', 'box__pad', 'widget--related-topics', 'related-topics--skeleton'),
    "data-qa": "related-topics-skeleton"
  }, Boolean(widgetTitle) && (0, _preact.h)("h3", {
    className: "widget-title related-topics__widget-title"
  }, (0, _preact.h)(_Skeleton.TextSkeleton, {
    width: "12em"
  })), (0, _preact.h)("ul", {
    className: "simple-topic-list"
  }, rows.map(function (i) {
    return (0, _preact.h)("li", {
      key: i,
      className: "related-topics__topic simple-topic-list--item"
    }, (0, _preact.h)("h4", {
      className: (0, _classnames.default)('h6', 'related-topics__topic-title', 'simple-topic-list--title')
    }, (0, _preact.h)(_Skeleton.TextSkeleton, {
      width: "92%",
      style: {
        maxWidth: '18em',
        display: 'block'
      }
    })), (0, _preact.h)(_Skeleton.TextSkeleton, {
      width: "7em",
      style: {
        display: 'block',
        marginTop: '0.35rem'
      }
    }));
  })));
};

exports.RelatedTopicsSkeleton = RelatedTopicsSkeleton;